import { Injectable, inject } from '@angular/core';

import { DeviceService, Page } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class DeviceInfoSerializerService {
    private readonly deviceService = inject(DeviceService);
    private readonly vnPage = inject(Page);

    serialize(format: DeviceInfoSerializationFormats = DeviceInfoSerializationFormats.Linear): string {
        return format === DeviceInfoSerializationFormats.JSON ? this.serializeAsJsonString() : this.serializeAsLinearString();
    }

    private serializeAsJsonString(): string {
        return `json,${JSON.stringify({
            activeTheme: `th-${this.vnPage.theme}`,
            deviceType: this.deviceService.deviceType,
            isAndroid: this.deviceService.isAndroid,
            isiOS: this.deviceService.isiOS,
            isChrome: this.deviceService.isChrome,
            isNexus: this.deviceService.isNexus,
            isTouch: this.deviceService.isTouch,
            isMobile: this.deviceService.isMobile,
            isMobilePhone: this.deviceService.isMobilePhone,
            isRobot: this.deviceService.isRobot,
            osName: this.deviceService.osName.trim().replace(/\s/g, '-'),
            osVersion: this.deviceService.osVersion,
            vendor: this.deviceService.vendor,
            browserName: this.deviceService.getCapability('browserName'),
            browserVersion: this.deviceService.getCapability('browserVersion'),
        })}`;
    }

    private serializeAsLinearString(): string {
        return `linear, th-${this.vnPage.theme},
            ${this.deviceService.deviceType},
            ${this.deviceService.isAndroid},
            ${this.deviceService.isiOS},
            ${this.deviceService.isChrome},
            ${this.deviceService.isNexus},
            ${this.deviceService.isTouch},
            ${this.deviceService.isMobile},
            ${this.deviceService.isMobilePhone},
            ${this.deviceService.isRobot},
            ${this.deviceService.osName.trim().replace(/\s/g, '-')},
            ${this.deviceService.osVersion},
            ${this.deviceService.vendor},
            ${this.deviceService.getCapability('browserName')},
            ${this.deviceService.getCapability('browserVersion')},
        `;
    }
}

export enum DeviceInfoSerializationFormats {
    JSON = 0,
    Linear,
}
